<template>
  <vs-card class="card-audio-podcast">
    <template v-if="isDesktop">
      <template v-if="detail.thumbPodcast">
        <img class="img-thumbpodcast" :src="detail.thumbPodcast.image_path" />
      </template>
      <template v-else-if="thumbPath">
        <img class="img-thumbpodcast" :src="thumbPath" />
      </template>
      <div class="podcast-content">
        <div class="podcast-title">
          <marquee direction="left"><h5>{{ detail.content.title.data }}</h5></marquee>
          <!-- <h5>{{ detail.content.title.data }}</h5> -->
        </div>
        <vue-plyr ref="detailPlyrAudio" :emit="['ended']" @ended="$emit('playNextOnPlaylist')">
          <audio controls crossorigin playsinline :autoplay="autoplay">
            <source :src="audioLink" :type="audioType" />
          </audio>
        </vue-plyr>
      </div>

    </template>
    <template v-else>
      <div>
        <div class="flex">
          <template v-if="detail.thumbPodcast">
            <img class="img-thumbpodcast" :src="detail.thumbPodcast.image_path" />
          </template>
          <template v-else-if="thumbPath">
            <img class="img-thumbpodcast" :src="thumbPath" />
          </template>
          <div class="podcast-title podcast-title-mobile">
            <!-- <marquee direction="left"><h5>{{ detail.content.title.data }}</h5></marquee> -->
            {{ detail.content.title.data }}
          </div>
        </div>
        <div class="podcast-content">
          
          <vue-plyr ref="detailPlyrAudio" :emit="['ended']" @ended="$emit('playNextOnPlaylist')">
            <audio controls crossorigin playsinline :autoplay="autoplay">
              <source :src="audioLink" :type="audioType" />
            </audio>
          </vue-plyr>
        </div>
      </div>
    </template>
  </vs-card>
</template>

<script>
import formatFieldHelper from '../../../helpers/format-field-helper';
import generalHelper from '../../../helpers/general-helper';
export default {
  data() {
    return {
      thumbPath: ""
    }
  },
  props: {
    detail: {
      type: Object,
      require: true,
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    currentCommodity: {
      require: true,
    },
  },
  async created() {
    await this.getThumbPath();
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    audioLink() {
      if (this.detail) {
        return this.detail.audio.image_path;
      }
      return "";
    },
    audioType() {
      if (this.detail && this.detail.audio) {
        if (this.detail.audio.metadata && this.detail.audio.metadata.mimetype) {
          return this.detail.audio.metadata.mimetype;
        } else if (this.detail.audio.extension) {
          return `audio/${this.detail.audio.extension}`;
        }
      }
      return "";
    },
    audioPlayer() {
      return this.$refs.detailPlyrAudio.player;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    async getThumbPath() {
      if (this.detail && this.detail.thumb) {
        const exist = await generalHelper.checkImageExist(this.detail.thumb.image_path);
        if (exist) {
          this.thumbPath = this.detail.thumb.image_path;
          return;
        }
      }
      let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
      if (this.currentCommodity && this.currentCommodity.id && this.currentCommodity.id > 0) {
        this.thumbPath = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
      } else {
        this.thumbPath = require(`../../../assets/images/commodity/${originCode}/${this.detail.subjects[0].code}.png`);
      }
    },
  }
};
</script>

<style lang="scss">
.card-audio-podcast {
  .con-vs-card {
    border-radius: 6px;
  }
  .vs-card--content {
    display: flex;
  }
  .podcast-content {
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .podcast-title {
      min-height: 6rem;
    }
  }
  .podcast-title-mobile {
    min-height: 6rem;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.2;
    color: #028a13;
  }
}
.theme-dark .card-audio-podcast {
  background-color: #282e34;
}
</style>